export const INELIGIBLE_REASONS = {
  unavailableState: 'unavailable_state',
  ineligibleAge: 'ineligible_age',
  accutane: 'using_accutane',
} as const;

export type INELIGIBILITY_REASONS = valueof<typeof INELIGIBLE_REASONS>;
